// CONTEXTS
import { ProductsProvider } from "../../contexts/products/products.context";
// COMPONENTS
import LoggedIn from "../../layouts/loggedIn.layout";
import ProductsPage from "./page.products.page";

const ProductsLayout = () => {
  return (
    <LoggedIn>
      <ProductsProvider>
        <ProductsPage />
      </ProductsProvider>
    </LoggedIn>
  );
};

export default ProductsLayout;
